export type CookieOptions = {
  path?: string
  domain?: string
  secure?: boolean
  sameSite?: 'Lax' | 'Strict' | 'None' | string
  expires?: number | Date
  maxAge?: number
}

const buildCookieString = (name: string, value: string, options?: CookieOptions): string => {
  const parts: string[] = []

  parts.push(`${name}=${value}`)

  if (options) {
    if (options.path) parts.push(`path=${options.path}`)
    if (options.domain) parts.push(`domain=${options.domain}`)
    if (options.secure) parts.push('secure')
    if (options.sameSite) parts.push(`SameSite=${options.sameSite}`)
    if (options.maxAge !== undefined) parts.push(`max-age=${options.maxAge}`)
    if (options.expires) {
      const expires =
        typeof options.expires === 'number'
          ? new Date(Date.now() + options.expires * 1000)
          : options.expires

      parts.push(`expires=${expires.toUTCString()}`)
    }
  }

  return parts.join('; ')
}

export const setCookie = (name: string, value: string, options?: CookieOptions): void => {
  document.cookie = buildCookieString(name, encodeURIComponent(value), options)
}

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2) {
    const raw = parts.pop()?.split(';').shift() || ''

    try {
      return decodeURIComponent(raw)
    } catch {
      return raw
    }
  }

  return null
}

export const removeCookie = (
  name: string,
  options?: Partial<Pick<CookieOptions, 'path' | 'domain'>>,
): void => {
  setCookie(name, '', {
    path: options?.path ?? '/',
    domain: options?.domain,
    expires: new Date(0),
  })
}

export const hasCookie = (name: string): boolean => {
  return getCookie(name) !== null
}
